import type { IntakeSpec, PrintingMiniatureDetails } from '@shared/types';
import type { Part, Joint, Feature } from '@shared/spec';

function getDetails(intake: IntakeSpec): PrintingMiniatureDetails {
  return intake.details as PrintingMiniatureDetails;
}

export function parts(intake: IntakeSpec): Part[] {
  const d = getDetails(intake);
  const bboxW = intake.core.size?.length ?? 30;
  const bboxD = intake.core.size?.width ?? 30;
  const bboxH = intake.core.size?.height ?? 40;

  const result: Part[] = [
    {
      id: 'figure',
      name: d.miniType,
      kind: 'custom',
      materialId: 'mat-primary',
      openscadSnippet: `// ${d.miniType} miniature placeholder`,
      boundingBox: {
        w: bboxW,
        d: bboxD,
        h: bboxH,
      },
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      tags: ['miniature'],
      paramRefs: [],
    },
  ];

  if (d.basePresent) {
    result.push({
      id: 'base',
      name: 'ベース',
      kind: 'panel',
      materialId: 'mat-primary',
      width: bboxW + 4,
      depth: bboxD + 4,
      thickness: 2,
      cutouts: [],
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      tags: ['base'],
      paramRefs: [],
    });
  }

  return result;
}

export function joints(_intake: IntakeSpec): Joint[] {
  return [];
}

export function features(_intake: IntakeSpec): Feature[] {
  return [];
}
